import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from 'routes';
import SecureRoute from 'routing/SecureRoute';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {Object.entries(routes).map(([key, { insecure, component: Component, path, ...rest }]) => {
        const element = insecure ? <Component {...rest} /> : <SecureRoute component={Component} {...rest} />;

        return <Route key={key} path={path} element={element} />;
      })}

      <Route path="*" element={<Navigate to={routes.NotFound.path} />} />
    </Routes>
  );
};

export default AppRoutes;
